import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import {
  selectCurrentRole,
  selectIsAuthenticated,
} from '../../slices/authSlice';
import { useGetMeQuery } from '../../api/authApi';
import styles from './RequireRole.module.css';

export default function RequireRole({ allow }) {
  const hasToken = useSelector(selectIsAuthenticated);
  const role = useSelector(selectCurrentRole);
  const location = useLocation();

  const { isLoading, isError } = useGetMeQuery(undefined, {
    skip: !hasToken || Boolean(role),
  });

  if (!hasToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (isLoading || (!role && !isError)) {
    return <p className={styles.loading}>Loading…</p>;
  }

  if (isError || !role) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!allow.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
